import React from 'react';
export function StarsBackground() {
  // Generate random stars
  const stars = Array.from({
    length: 50
  }).map((_, i) => {
    const size = Math.random() * 2 + 1;
    const top = Math.random() * 100;
    const left = Math.random() * 100;
    const animationDelay = `${Math.random() * 4}s`;
    const opacity = Math.random() * 0.5 + 0.3;
    return <div key={i} className="absolute rounded-full bg-white animate-twinkle" style={{
      width: `${size}px`,
      height: `${size}px`,
      top: `${top}%`,
      left: `${left}%`,
      opacity,
      animationDelay
    }} data-id="element-200" />;
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-201">
      {stars}
    </div>;
}